"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ReportBlockTradeSidePaneContainer = _interopRequireDefault(require("../../ReportBlockTradeSidePaneComponents/ReportBlockTradeSidePaneContainer"));
var _ApiKeysSidePaneComponent = _interopRequireDefault(require("../../ApiKeysSidePaneComponents/ApiKeysSidePane/ApiKeysSidePaneComponent"));
var _AdvancedOrderFormContainer = _interopRequireDefault(require("../../OrderEntryComponents/advancedForm/AdvancedOrderFormContainer"));
var _SendReceiveSidePaneContainer = _interopRequireDefault(require("../../SendReceiveSidePane/SendReceiveSidePaneContainer"));
var _KYC_AGForm = _interopRequireDefault(require("../../KYC_AcuantGo/KYC_AGForm"));
var _KYC_IMForm = _interopRequireDefault(require("../../KYC_IM/KYC_IMForm"));
var _KYC_IMLegacyForm = _interopRequireDefault(require("../../KYC_IMLegacy/KYC_IMLegacyForm"));
var _KYC_JumioIframe = _interopRequireDefault(require("../../KYC_Jumio/KYC_JumioIframe"));
var _KYC_ManualForm = _interopRequireDefault(require("../../KYC_Manual/KYC_ManualForm"));
var _ReportSidePaneComponent = _interopRequireDefault(require("../../ReportSidePaneComponents/ReportSidePaneComponent"));
var _DepositSidePaneComponent = _interopRequireDefault(require("../../DepositSidePaneComponents/DepositSidePaneComponent"));
var _WithdrawSidePaneComponent = _interopRequireDefault(require("../../WithdrawSidePaneComponents/WithdrawSidePaneComponent"));
var _FiatSidePaneContainer = _interopRequireDefault(require("../../Retail/RetailSidePanes/FiatSidePaneContainer"));
var _WhiteListAddressSidePaneContainer = _interopRequireDefault(require("../../WhiteListAddressSidepane/WhiteListAddressSidePaneContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  ReportBlockTrade: _ReportBlockTradeSidePaneContainer["default"],
  ApiKeys: _ApiKeysSidePaneComponent["default"],
  AdvancedOrder: _AdvancedOrderFormContainer["default"],
  SendReceive: _SendReceiveSidePaneContainer["default"],
  KYC_AGForm: _KYC_AGForm["default"],
  KYC_IMForm: _KYC_IMForm["default"],
  KYC_IMLegacyForm: _KYC_IMLegacyForm["default"],
  KYC_JumioForm: _KYC_JumioIframe["default"],
  KYC_ManualForm: _KYC_ManualForm["default"],
  Reports: _ReportSidePaneComponent["default"],
  Deposits: _DepositSidePaneComponent["default"],
  Withdraws: _WithdrawSidePaneComponent["default"],
  RetailFiat: _FiatSidePaneContainer["default"],
  WhiteListAddress: _WhiteListAddressSidePaneContainer["default"]
};